import { toValidAdminKey } from '../model/admin-panel-key'

/**
 * Administration-modal seam. Exposes the pure deep-link panel-key validator so
 * the modal narrows a `?modals=admin:<key>` value without value-importing
 * `model/` (the MVVM no-restricted-imports rule on model/). The modal supplies
 * the valid-key set built from `ADMIN_TARGETS`.
 */
export function useAdministrationModal() {
  return { toValidAdminKey }
}
